/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";
import { Alert, Button, Card, CardBody, FormGroup, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Col } from "reactstrap";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        username: localStorage.getItem('username') || "",
        old_password: "",
        new_password: "",
      },
      confirm_password: "",
      submitting: false,
      errorMessage: null,
      successMessage: null,
      validation: {}
    };
  }

  onKeyUp(e) {
    const charCode = typeof e.which === "undefined" ? e.keyCode : e.which;
    if (charCode === 13) {
      this.handleSubmit();
    }
  }

  handleInputChanged(e) {
    const nam = e.target.name;
    const val = e.target.value;

    if (nam === 'confirm_password') {
      // Keep confirm password outside of user to avoid sending it in payload
      this.setState({ confirm_password: val });
      return;
    }

    this.setState(prevState => {
      const user = { ...prevState.user };
      user[nam] = val;
      return { user };
    });
  }

  validate() {
    const { username, old_password, new_password } = this.state.user;
    const { confirm_password } = this.state;
    const errors = {};

    if (!username || username.trim().length === 0) {
      errors.username = "Username wajib diisi.";
    }
    if (!old_password || old_password.length === 0) {
      errors.old_password = "Password lama wajib diisi.";
    }

    // Standard safe password: min 8 chars, 1 uppercase, 1 lowercase, 1 digit, 1 special char
    const strongPwRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    if (!new_password || new_password.length === 0) {
      errors.new_password = "Password baru wajib diisi.";
    } else if (!strongPwRegex.test(new_password)) {
      errors.new_password = "Password baru harus minimal 8 karakter dan mengandung huruf besar, huruf kecil, angka, dan simbol.";
    }

    // Confirm password validation (only for validation, not for payload)
    if (!confirm_password || confirm_password.length === 0) {
      errors.confirm_password = "Konfirmasi password wajib diisi.";
    } else if (confirm_password !== new_password) {
      errors.confirm_password = "Konfirmasi password tidak sama dengan password baru.";
    }

    this.setState({ validation: errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit() {
    if (!this.validate()) {
      this.setState({ errorMessage: "Periksa kembali isian Anda.", successMessage: null });
      return;
    }

    const body = { ...this.state.user };
    console.log('body :: ',body)
    this.setState({ submitting: true, errorMessage: null, successMessage: null });

    fetch(process.env.REACT_APP_API_URL + '/minishop/user/change-password', {
      method: 'POST',
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then((data) => {
        if (!data || !data.header || data.header.status_code !== 200) {
          const msg = (data && data.header && data.header.message) ? data.header.message : 'Gagal mengubah password. Coba lagi.';
          return this.setState({ errorMessage: msg, submitting: false });
        }
        this.setState({
          successMessage: 'Password berhasil diubah. Silakan login dengan password baru Anda.',
          errorMessage: null,
          submitting: false,
          user: { username: this.state.user.username, old_password: '', new_password: '' },
          validation: {}
        });
      })
      .catch((err) => {
        this.setState({ errorMessage: 'Terjadi kesalahan jaringan. Coba lagi.', submitting: false });
      });
  }

  renderFieldError(name) {
    const { validation } = this.state;
    if (!validation || !validation[name]) return null;
    return (
      <div style={{ color: '#f5365c', fontSize: '0.8rem', marginTop: '0.25rem' }}>
        {validation[name]}
      </div>
    );
  }

  render() {
    return (
      <>
        <Col lg="5" md="7">
          <Card className="bg-secondary shadow border-0">
            <CardBody className="px-lg-5 py-lg-5">
              <div className="text-center text-muted mb-4">
                <small>Ubah password akun anda</small>
              </div>
              {this.state.errorMessage && (
                <Alert color="danger">
                  {this.state.errorMessage}
                </Alert>
              )}
              {this.state.successMessage && (
                <Alert color="success">
                  {this.state.successMessage}
                </Alert>
              )}
              <Form role="form">
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-satisfied" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Username"
                      type="text"
                      name="username"
                      value={this.state.user.username}
                      readOnly
                      onKeyUp={this.onKeyUp.bind(this)}
                      onChange={this.handleInputChanged.bind(this)}
                    />
                  </InputGroup>
                  {this.renderFieldError('username')}
                </FormGroup>
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Password Lama"
                      type="password"
                      name="old_password"
                      value={this.state.user.old_password}
                      onKeyUp={this.onKeyUp.bind(this)}
                      onChange={this.handleInputChanged.bind(this)}
                    />
                  </InputGroup>
                  {this.renderFieldError('old_password')}
                </FormGroup>
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Password Baru"
                      type="password"
                      name="new_password"
                      value={this.state.user.new_password}
                      onKeyUp={this.onKeyUp.bind(this)}
                      onChange={this.handleInputChanged.bind(this)}
                    />
                  </InputGroup>
                  {this.renderFieldError('new_password')}
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Konfirmasi Password Baru"
                      type="password"
                      name="confirm_password"
                      value={this.state.confirm_password}
                      onKeyUp={this.onKeyUp.bind(this)}
                      onChange={this.handleInputChanged.bind(this)}
                    />
                  </InputGroup>
                  {this.renderFieldError('confirm_password')}
                </FormGroup>
                <ul className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.25rem', paddingLeft: '1rem' }}>
                  <li>Minimal 8 karakter</li>
                  <li>Wajib mengandung huruf besar</li>
                  <li>Wajib mengandung huruf kecil</li>
                  <li>Wajib mengandung angka</li>
                  <li>Wajib mengandung simbol</li>
                </ul>
                <div className="text-center">
                  <Button
                    className="my-4"
                    color="primary"
                    type="button"
                    disabled={this.state.submitting}
                    onClick={() => this.handleSubmit()}>
                    {this.state.submitting ? 'Menyimpan...' : 'Ubah Password'}
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </>
    );
  }
}

export default ResetPassword;
